import React, { useState } from 'react'
import Select from "react-select"
import Creatable from "react-select/creatable"
import { Link, Switch, Route } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Dropdown, Select as AntSelect, Menu, List,Tabs, Popover, Badge } from 'antd'

import { AiOutlineClose, AiOutlineDown, AiOutlineMenu, AiOutlineReload } from 'react-icons/ai'

import { useToggle, useListData, usePet, stringifyDate } from '../../modules'
import { addItemToAccQueue, clearAccQueue, removeAccItem } from '../../store/actions'

const { Option } = AntSelect
const { TabPane } = Tabs

const Home = () => {
    const { user } = useSelector(state => state.application)
    const { queue } = useSelector(state => state.accounting)
    const [sp, setSp] = useState(null)

    const dispatch = useDispatch()

    const [selected, setSelected] = useState(null)
    const [string, setString] = useState('')
    const [storeName, setStoreName] = useState('')
    const [stores, setStores] = useState([])
    const [requests, setRequests] = useState(0)
    const [store, setStore] = useState()

    // const { option, setOption, dropdown } = useDropDown(['Select', 'Delete', 'Renew'])

    const [restockModal, toggleRestockModal] = useToggle()
    const [menu, toggleMenu] = useToggle()
    const [modifyQuantityModal, toggleModifyQuantityModal] = useToggle()
    const [inventoryItemModal, toggleInventoryItemModal] = useToggle()
    const [spoilageModal, toggleSpoilageModal] = useToggle()
    const [dispenseModal, toggleDispenseModal] = useToggle()
    const [invEdit, toggleInvEdit] = useToggle()
    const [inInv, toggleInInv] = useToggle()
    const [outInv, toggleOutInv] = useToggle()
    const [request, toggleRequest] = useToggle()
    const [selectMode, toggleSelectMode] = useToggle(queue.length > 0)

    const [, getSaleItem] = usePet('saleItemByInvItem', { id: selected?._id }, { notify: true, callback: ({ data }) => dispatch(addItemToAccQueue(selected.item, data.price)), manual: true })

    const [, getRequests] = usePet('requestsByStore', { store: store?.value, type: "Received", classif: 'Pending' }, { notify: true, manual: true, callback: ({ data }) => setRequests(data.count) })

    const [,{ list: invoices = [] }] = useListData('invoices', { string: '' }, { notify: true, manual: false })
    
    const [,{ list: purchaseOrders = [] }] = useListData('purchaseOrders', { string: '' }, { notify: true, manual: false })

    const [
        { loading: invLoading, error: invError, fetch },
        { list: inventory = [] },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('inventory', {
        store: store?.value,
        string
    }, { notify: true, manual: true })

    const refresh = () => {
        fetch()
        getRequests()
        navigate(1)
    }

    const [{ loading: alLoading, error: alError }, getAllowed] = usePet('myAllowedStores', {
        name: storeName
    }, {
        notify: true, callback: ({ data }) => {
            let allowed = data?.map(st => ({
                ...st,
                label: st?.store?.name,
                value: st?.store?._id,
                permissions: st?.permissions
            }))

            if (allowed?.length > 0) {
                setStores(allowed)
                setStore(allowed[0])
                refresh()
            }
        }
    })

    const [{ loading: stoLoading }, newStore] = usePet('newStore', {
        name: storeName
    }, { notify: true, callback: getAllowed, manual: true, load: { msg: 'Adding store...' } })

    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0)
            refresh()
    }

    const selectStore = val => {
        setStore(val)
        refresh()
    }
    
    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Procurement</h2>
                    <span className="flex items-center justify-between">
                        <Dropdown
                            overlay={
                                <Menu>
                                    <Link to="/app/procurement/suppliers/new">
                                        <Menu.Item>Add Supplier</Menu.Item>
                                    </Link>
                                    <Link to="/app/procurement/invoices/new">
                                        <Menu.Item>Receive Invoice</Menu.Item>
                                    </Link>
                                    <Link to="/app/procurement/purchase-orders/new">
                                        <Menu.Item>Generate Purchase Order</Menu.Item>
                                    </Link>
                                </Menu>
                            }>
                            <button className="btn hisani-btn-green-light text-white">
                                <span className="hidden xs:block mr-2">Actions</span>
                                <AiOutlineDown />
                            </button>
                        </Dropdown>
                        <button onClick={refresh} className="btn ml-2 py-2.5 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                    </span>
                </header>
                <div className="p-3 grid gap-4 grid-cols-3">
                    <div className="flex flex-col rounded-sm border mb-3 border-gray-200 px-4 pt-3 pb-5">
                        <div className="flex items-center mb-1 justify-between border-b-2 border-gray-200 w-full pb-2">
                            <p className="font-medium text-sm mb-0">Critical Items</p>
                            <Link to={`/app/procurement/stores`}>
                                <button className="btn py-1 shadow-none bg-white hover:bg-gray-100 hover:text">View All</button>
                            </Link>
                        </div>
                        <List
                            className="small-card-list"
                            dataSource={[1, 2, 3, 4, 5, 6]}
                            renderItem={(item, i) => (
                                <List.Item key={i}>
                                    <List.Item.Meta
                                        title={ <><p className="my-0">Diclofenac Injection</p><p className="text-red-500 my-0">20 tablets Left</p></> }
                                        description="Main Store"
                                    />
                                    <button className="btn py-1 mr-2 shadow-none bg-white hover:bg-gray-100 hover:text">View Usage</button>
                                </List.Item>
                            )} />
                    </div>
                    {/* <div className="flex items-center mb-1 justify-between border-b-2 border-gray-200 w-full pb-2">
                        <p className="font-medium text-sm mb-0">Latest Invoices</p>
                        <Link to={`/app/procurement/stores`}>
                            <button className="btn py-1 shadow-none bg-white hover:bg-gray-100 hover:text">View All</button>
                        </Link>
                    </div> */}
                    <div className="flex flex-col rounded-sm border mb-3 border-gray-200 px-4 pt-1.5 pb-5">
                        <Tabs>
                            <TabPane key="0" tab="Latest Invoices">
                                <List
                                    className="small-card-list-req"
                                    dataSource={ invoices }
                                    renderItem={(invoice, i) => (
                                        <List.Item key={i}>
                                            <List.Item.Meta
                                                title={ invoice?.supplier?.name }
                                                description={ <div className="flex items-center ml-1"><div className={ `w-2 h-2 mr-1 my-0 rounded-full ${ invoice?.committed ? 'bg-green-500' : 'bg-yellow-500' } shadow` } />{ invoice.code }</div> }
                                            />
                                            <Link to={`/app/procurement/invoices/${invoice?._id}`}>
                                                <button className="btn py-1 mr-2 shadow-none bg-white hover:bg-gray-100 hover:text">View</button>
                                            </Link>
                                        </List.Item>
                                    )} />
                                <div className="text-right w-full mt-2 pt-1">
                                    <Link to={`/app/procurement/invoices`}>
                                        <button className="btn py-1 shadow-none bg-white hover:bg-gray-100 hover:text">View All</button>
                                    </Link>
                                </div>
                            </TabPane>
                            <TabPane key="1" tab="Purchase Orders">
                                <List
                                    className="small-card-list-req"
                                    dataSource={ purchaseOrders }
                                    renderItem={(po, i) => (
                                        <List.Item key={i}>
                                            <List.Item.Meta
                                                title={ po?.supplier?.name }
                                                description={ po?.supplier?.name }
                                            />
                                            <Link to={`/app/procurement/purchase-orders/${po?._id}`}>
                                                <button className="btn py-1 mr-2 shadow-none bg-white hover:bg-gray-100 hover:text">View</button>
                                            </Link>
                                        </List.Item>
                                    )} />
                                <div className="text-right w-full mt-2 pt-1">
                                    <Link to="/app/procurement/purchase-orders">
                                        <button className="btn py-1 shadow-none bg-white hover:bg-gray-100 hover:text">View All</button>
                                    </Link>
                                </div>
                            </TabPane>
                        </Tabs>
                    </div>
                    <div className="flex flex-col rounded-sm border mb-3 border-gray-200 px-4 pt-3 pb-5">
                        <div className="flex items-center mb-1 justify-between border-b-2 border-gray-200 w-full pb-2">
                            <p className="font-medium text-sm mb-0">New Requisition Forms</p>
                            <Link to={`/app/procurement/stores`}>
                                <button className="btn py-1 shadow-none bg-white hover:bg-gray-100 hover:text">View All</button>
                            </Link>
                        </div>
                        <List
                            className="small-card-list"
                            dataSource={[1, 2, 3, 4, 5]}
                            renderItem={(item, i) => (
                                <List.Item key={i}>
                                    <List.Item.Meta
                                        title="Nursing Department"
                                        description="Sent by Evans Kimani"
                                    />
                                    <button className="btn py-1 shadow-none bg-white hover:bg-gray-100 hover:text">View</button>
                                </List.Item>
                            )} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home